var React = require('react');

function ChevronDownDark (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"arrow"),React.createElement("g",{"id":"//-Symbols","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round","key":1},React.createElement("g",{"id":"configure-select","transform":"translate(-386.000000, -52.000000)","stroke":"#000000","strokeWidth":"2"},React.createElement("g",{"id":"arrow","transform":"translate(387.500000, 53.500000)"},React.createElement("polyline",{"id":"Path","points":"12 0 6 6 0 0"}))))]);
}

ChevronDownDark.defaultProps = {"width":"15px","height":"9px","viewBox":"0 0 15 9","version":"1.1"};

module.exports = ChevronDownDark;

ChevronDownDark.default = ChevronDownDark;
